import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

function CompanySection({ company, onChange }) {
  function update(field, value) {
    onChange({ company: { ...company, [field]: value } });
  }

  return (
    <section className="form-section">
      <h2 className="form-section-title">Empresa</h2>
      <div className="grid grid-cols-2 gap-4">
        <div className="col-span-2">
          <Label className="text-slate-600 text-sm">Nombre</Label>
          <Input value={company.name} onChange={function(e) { update("name", e.target.value); }} placeholder="Elite Motor Group" className="input-elite mt-1" data-testid="company-name" />
        </div>
        <div className="col-span-2">
          <Label className="text-slate-600 text-sm">Dirección</Label>
          <Input value={company.address} onChange={function(e) { update("address", e.target.value); }} placeholder="Calle Principal 123" className="input-elite mt-1" data-testid="company-address" />
        </div>
        <div>
          <Label className="text-slate-600 text-sm">Ciudad</Label>
          <Input value={company.city} onChange={function(e) { update("city", e.target.value); }} placeholder="Madrid" className="input-elite mt-1" data-testid="company-city" />
        </div>
        <div>
          <Label className="text-slate-600 text-sm">C.P.</Label>
          <Input value={company.postalCode} onChange={function(e) { update("postalCode", e.target.value); }} placeholder="28001" className="input-elite mt-1" data-testid="company-postal" />
        </div>
        <div>
          <Label className="text-slate-600 text-sm">CIF</Label>
          <Input value={company.cif} onChange={function(e) { update("cif", e.target.value); }} placeholder="B12345678" className="input-elite mt-1" data-testid="company-cif" />
        </div>
        <div>
          <Label className="text-slate-600 text-sm">Teléfono</Label>
          <Input value={company.phone} onChange={function(e) { update("phone", e.target.value); }} placeholder="+34 91 123 45 67" className="input-elite mt-1" data-testid="company-phone" />
        </div>
        <div className="col-span-2">
          <Label className="text-slate-600 text-sm">Email</Label>
          <Input type="email" value={company.email} onChange={function(e) { update("email", e.target.value); }} placeholder="info@empresa.com" className="input-elite mt-1" data-testid="company-email" />
        </div>
      </div>
    </section>
  );
}

export default CompanySection;
